var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEdit = function SvgEdit(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m26.068 5.53-3.592-3.592a3.187 3.187 0 0 0-4.505 0L3.893 16.017a3.1 3.1 0 0 0-.743 1.192l-2.054 6.053c-.26 1.071.026 2.15.76 2.887.548.547 1.285.845 2.104.845q.426 0 .872-.109l5.966-2.03c.447-.152.86-.41 1.192-.742l14.078-14.078a3.19 3.19 0 0 0 0-4.504M11.283 21.993l-5.269-5.268L17.071 5.667l5.269 5.268zm-7.008 2.974c-.396.098-.76.012-1.004-.231a1 1 0 0 1-.256-.916l1.844-5.422 4.752 4.75zM24.654 8.621l-.9.9-5.269-5.269.9-.9a1.18 1.18 0 0 1 1.677 0l3.592 3.593a1.187 1.187 0 0 1 0 1.676"
  })));
};
export default SvgEdit;